import axios from 'axios';
const BASE_URL = process.env.REACT_APP_ENDPOINT;

export default axios.create({
  baseURL: BASE_URL,
  //headers: { 'Content-Type': 'application/json' },
  //withCredentials: true
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});


/*tutorial link=>https://www.youtube.com/watch?v=nI8PYZNFtac&t=1981s
 * code from => https://github.com/gitdagray/react_jwt_auth/tree/main/src/api
 */
